<template>
  <v-container style="padding-top: 0px; padding-bottom: 0px">
    <v-row align="center">
      <v-col cols="12" sm="3" style="padding-right: 10px">
        <v-text-field
          :readonly="readonly"
          required
          :rules="NameRules"
          variant="underlined"
          label="Display text"
          v-model="helpfulLink.display"
          auto-grow
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="5" style="padding-right: 10px">
        <v-text-field :readonly="readonly" variant="underlined" :rules="NameRules" label="URL" v-model="helpfulLink.url" auto-grow></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field readonly type="number" variant="underlined" label="Display Order" :model-value="index"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-row   v-if="!readonly">
          <v-icon class="me-3" @click="deleteHelpfulLink">mdi-delete-outline</v-icon>
          <v-icon :title="valid ? 'Valid' : 'Invalid'" :style="`color: ${valid ? 'green' : 'red'}`">{{
            valid ? 'mdi-check' : 'mdi-alert-circle'
          }}</v-icon>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'HelpfulLink',
  data: () => ({
    expanded: false
  }),
  methods: {
    deleteHelpfulLink() {
      this.$emit('deleteHelpfulLink', this.helpfulLink)
    }
  },
  computed: {
    NameRules: {
      get: function() {
        return [
          v => !!v || 'Required',
          v => (v && v.trim().length >= 1) || `Minimum length is 1`,
          v => (v && v.trim().length <= 500) || `Maximum length is 500`
        ]
      }
    }
  },
  props: {
    helpfulLink: Object,
    valid: {
      type: Boolean,
      default: false
    },
    readonly: Boolean,
    index: Number
  },
  watch: {
    // eslint-disable-next-line
    index: function(newVal, oldVal) {
      console.log(`helpful link watch index`);
      this.helpfulLink.displayOrder = newVal
    }
  },
  mounted() {
    this.helpfulLink.displayOrder = this.index
  }
}
</script>
